import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Internal imports
import SectionGrid from '~/app/Components/Dashboard/OverviewV2/primitives/SectionGrid.jsx';
import { moneyFormatter } from '~/app/webHelpers.js';

import XlinkAPI from '~/app/api/xlinkAPI';
import { actions } from '~/app/redux/overview/duck';

const CollectedFees = () => {
  const dispatch = useDispatch();
  const currentView = useSelector(
    state => state.drilldown.drilldownHistory[state.drilldown.drilldownHistory.length - 1],
  );

  useEffect(() => {
    let active = true;
    const fetchFeesCards = async () => {
      dispatch(actions.fetchFeesCards());

      try {
        const resp = await XlinkAPI.getCollectedFees();
        const feeValues = Object.fromEntries(
          Object.entries(resp.data.fees).map(([key, value]) => [
            key,
            key === 'total' ? value.requested : value.collected,
          ]),
        );
        if (active) {
          dispatch(actions.fetchFeesCardsSuccess(feeValues));
        }
      } catch (error) {
        if (active) {
          dispatch(actions.fetchFeesCardsFailure?.(error));
        }
      }
    };

    fetchFeesCards();
    return () => {
      active = false;
    };
  }, [dispatch, currentView?.loginID, currentView?.preparerID, currentView?.dd_token]);
  const feesCardsState = useSelector(state => state.dashboardOverview.feesCards);
  const feesCardsData = feesCardsState.data;

  const feesCards = [
    {
      key: 1,
      count: ` ${moneyFormatter(feesCardsData?.total || 0, false)}`,
      title: 'Requested Fees',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
    {
      key: 2,
      count: ` ${moneyFormatter(feesCardsData?.ef || 0, false)}`,
      title: 'Paid Fees',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
    {
      key: 3,
      count: ` ${moneyFormatter(feesCardsData?.preparer || 0, false)}`,
      title: 'Preparer Fees',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
    {
      key: 4,
      count: ` ${moneyFormatter(feesCardsData?.rss_addon || 0, true)}`,
      title: 'Transmitter Add On',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
    {
      key: 5,
      count: ` ${moneyFormatter(feesCardsData?.tran || 0, true)}`,
      title: 'Transmitter Fees',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
    {
      key: 6,
      count: ` ${moneyFormatter(feesCardsData?.tech || 0, false)}`,
      title: 'Tech Access Fees',
      loading: feesCardsState?.loading,
      error: feesCardsState?.error,
    },
  ];

  return <SectionGrid cards={feesCards} title="Collected Fees"></SectionGrid>;
};

export default CollectedFees;
